import { Component, Input } from '@angular/core';

@Component({
    selector: 'pim-product-identifier-link',
    templateUrl: './product-identifier-link.component.html',
    styleUrls: ['./product-identifier-link.component.sass'],
    standalone: false
})
export class ProductIdentifierLinkComponent {

	routeParams: { productIdentifier: string } = {productIdentifier: ''};

	@Input()
	set productIdentifier(identifier: string | undefined | null) {
		if (!identifier) {
			return;
		}
		this.routeParams.productIdentifier = identifier;
	}
}
